import axios from 'axios'
import axiosRetry from "axios-retry";
import store from '@/store';
import { requestOptions } from '@/helpers/request-options'

const partApiClient = axios.create({
})

axiosRetry(partApiClient, {
    retries: 3,
    retryDelay: () => 3000,
    retryCondition: () => true,
})

const apiSource = process.env.VUE_APP_API;

export default {
    GetManufacturerListing() {
        return partApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/search/ManufacturerListing`
            )
        )
    },
    GetPartDetail(uuid = null, euid = null) {
        var url;

        if (uuid != null && euid != null) {
            url = `/api/v1/${store.state.instance}/part/Detail?puid=${uuid}&euid=${euid}`;
        } else if (uuid == null && euid != null) {
            url = `/api/v1/${store.state.instance}/part/Detail?euid=${euid}`;
        } else if (uuid != null && euid == null) {
            url = `/api/v1/${store.state.instance}/part/Detail?puid=${uuid}`;
        }

        return partApiClient(
            requestOptions.get(
                apiSource + url
            )
        )
    },
    GetSearchPage(manufacturerId, searchTerm, searchType, page) {
        if (manufacturerId == undefined)
            manufacturerId = "";
        if (searchTerm == undefined)
            searchTerm = "";
        if (searchType == undefined)
            searchType = "";
        if (page == undefined)
            page = 1;
        return partApiClient(
            requestOptions.get(
                apiSource + `/api/v1/${store.state.instance}/search/Search?mfrId=${manufacturerId}&searchTerm=${searchTerm}&searchType=${searchType}&page=${page}`
            )
        )
    },
    SubmitPartRequest(partRequest) {
        return partApiClient(
            requestOptions.postData(
                partRequest,
                apiSource + `/api/v1/${store.state.instance}/part/SubmitPartRequest`
            )
        )
    },
}